<template lang="pug">
.banner-information(v-if="bannerList && bannerList.length >= 1", class="aspect-[300/55]")
  .banner-information-wrapper
    client-only
      swiper-container.w-full.h-full(ref="bannerInfoSwiper", :modules="[Autoplay]", direction="horizontal", slidesPerView="1", loop="true", autoplay-delay="2500", autoplay-disable-on-interaction="false", autoplay-pause-on-interaction="false", autoplay-stop-on-interaction="false", lazy="true", :navigation="false", :pagination="false")
        swiper-slide.gtm-activity-item.cursor-pointer.flex.gap-x-1.items-center.px-9(v-for="banner in bannerList", :key="banner.activityNo", data-location="ad", :data-activity-no="banner.activityNo", :data-template="banner.template", :data-activity-name="banner.name")
          img.rounded-lg.h-full(class="w-1/2 aspect-[5/2]", :src="getImageUrl(banner, 'adSmallUrl')", loading="lazy", :alt="getTitle(banner)")
          .flex.items-center.flex-1.font-bold.text-sm.text-white.text-center.h-12
            .m-auto {{ banner.name }}
      .promotion-nav-prev.cursor-pointer(@click="prev")
      .promotion-nav-next.cursor-pointer(@click="next")
</template>

<script setup>
import { ref, computed } from 'vue'
import { Autoplay } from 'swiper/modules'
import { useMainStore } from '@/stores/main'
import { useNuxtApp } from '#app'
import filterLocaleSetting from '@/utils/localeSetting'

const props = defineProps({
  sourceList: {
    type: Array,
    default: () => [],
  },
})

const { $analytics } = useNuxtApp()
const mainStore = useMainStore()
const { setModal, setModalParams } = mainStore
const { activityList } = useActivity('banner-information')
const { locale } = useI18n()
const { locale: defaultLocale } = useSite()

const bannerInfoSwiper = ref(null)

const bannerList = computed(() => {
  // 只有同時設置「輪播圖」與「廣告圖」才會出現在登入頁面的小輪播
  return props.sourceList.filter(({ displayMode }) => displayMode === 'both')
})

const swiper = computed(() => {
  return bannerInfoSwiper.value?.swiper
})

const getImageUrl = (campaign, name) => {
  if (campaign.activityTypeName?.toUpperCase() === 'PROMOTIONS') {
    return filterLocaleSetting(campaign.localeSetting, locale, defaultLocale, name)
  } else {
    return campaign[name]?.[0]?.url || ''
  }
}

const getTitle = (campaign) => {
  return filterLocaleSetting(campaign.localeSetting, locale, defaultLocale, 'title')
}

const prev = () => {
  swiper.value?.slidePrev()
}

const next = () => {
  swiper.value?.slideNext()
}
</script>

<style lang="scss">
.banner-information {
  position: relative;
  border-radius: 0.5rem;
  background-color: rgba(0, 0, 0, 0.6);
  //width: 100%;
  //max-width: 28rem;
  margin-inline-start: auto;
  margin-inline-end: auto;

  @media (orientation: portrait) and (min-width: 640px) {
    max-width: 36rem;
  }

  &-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  @media (min-aspect-ratio: 16/7) {
    display: none;
  }
}

.promotion-nav-prev {
  position: absolute;
  inset-inline-end: calc(100% - 1.75rem);
  top: 50%;
  z-index: 1;
  width: 1.75rem;
  height: 1.75rem;
  background-image: url('assets/images/list/list_img_forward_normal.png');
  background-size: contain;
}

.promotion-nav-next {
  position: absolute;
  inset-inline-start: calc(100% - 1.75rem);
  top: 50%;
  z-index: 1;
  width: 1.75rem;
  height: 1.75rem;
  background-image: url('assets/images/list/list_img_forward_normal.png');
  background-size: contain;
}

[dir="ltr"] .promotion-nav-next {
  transform: translateY(-50%) rotate(-180deg);
}

[dir="rtl"] .promotion-nav-next {
  transform: translateY(-50%) rotate(0deg);
}

[dir="ltr"] .promotion-nav-prev {
  transform: translateY(-50%) rotate(0deg);
}

[dir="rtl"] .promotion-nav-prev {
  transform: translateY(-50%) rotate(-180deg);
}
</style>
